<template>
    <AppLayout title="">
        <div class="card">
            <div class="card-body p-5">
                <div class="text-center px-2">
                    <img src="/images/illustrations/sketchy-1/2.png" alt="" class="mw-100 mh-300px" />
                </div>
                <div class="card-px text-center py-20 my-10">
                    <!-- <h2 class="fs-2x fw-bold mb-10">Bienvenido</h2>

                    <p class="text-gray-400 fs-5 fw-semobold mb-13">
                        <span>There are no customers added yet. <br />Kickstart your CRM by adding a your first
                            customer</span>
                    </p>

                    <button type="button" class="btn btn-primary er fs-6 px-8 py-4">
                        Añadir
                    </button> -->

                </div>


            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout'
</script>

